// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ---- from App.css lines 160-1223 ---- */
/* ======================================================================
   LIGHT THEME — override mirati per le dashboard live.
   Tutti i selettori sono ancorati a \`.rs-live-root\` così il tema chiaro
   agisce SOLO sulle pagine che lo opt-in (RaceLive, PilotLive, LivePublic)
   e NON tocca il resto della piattaforma.
====================================================================== */
[data-theme="light"] .rs-live-root {
  background: var(--rs-bg-0) !important;
  color: var(--rs-text-0);
}

/* Le dashboard live usano tutta la larghezza disponibile */
.rs-live-root.main {
  max-width: 1600px;
  padding-left: 24px;
  padding-right: 24px;
}
@media (min-width: 1800px) {
  .rs-live-root.main {
    max-width: 1760px;
  }
}
@media (max-width: 768px) {
  .rs-live-root.main {
    padding-left: 10px;
    padding-right: 10px;
  }
}

/* Sfondo pagina e decorazioni globali */
[data-theme="light"] .rs-live-root .bg-grid {
  background:
    linear-gradient(rgba(11, 13, 18, 0.06) 1px, transparent 1px) 0 0 / 24px 24px,
    linear-gradient(90deg, rgba(11, 13, 18, 0.06) 1px, transparent 1px) 0 0 / 24px 24px;
  opacity: 0.5;
}
[data-theme="light"] .rs-live-root .bg-glow,
[data-theme="light"] .rs-live-root .bg-glow-1,
[data-theme="light"] .rs-live-root .bg-glow-2 {
  opacity: 0.35;
  filter: saturate(0.75);
}

/* ---------- TOPBAR PREMIUM ---------- */
[data-theme="light"] .rs-live-root .topbar-premium {
  background: linear-gradient(180deg, #ffffff, #f3f5f8) !important;
  border-bottom: 1px solid var(--rs-border-0);
  box-shadow: var(--rs-shadow-sm);
}
[data-theme="light"] .rs-live-root .topbar-premium-circuit,
[data-theme="light"] .rs-live-root .topbar-premium-laps,
[data-theme="light"] .rs-live-root .topbar-premium-drivers {
  color: var(--rs-text-1);
}
[data-theme="light"] .rs-live-root .topbar-premium-circuit svg,
[data-theme="light"] .rs-live-root .topbar-premium-laps svg,
[data-theme="light"] .rs-live-root .topbar-premium-drivers svg {
  color: var(--rs-text-2);
}
[data-theme="light"] .rs-live-root .topbar-premium-separator {
  background: var(--rs-border-0);
}
[data-theme="light"] .rs-live-root .topbar-premium-status {
  background: rgba(4, 120, 87, 0.12);
  border-color: rgba(4, 120, 87, 0.35);
  color: var(--rs-success);
}
[data-theme="light"] .rs-live-root .topbar-premium-status--finita {
  background: var(--rs-surface-2);
  border-color: var(--rs-border-0);
  color: var(--rs-text-1);
}
[data-theme="light"] .rs-live-root .topbar-premium-viewers {
  color: var(--rs-info);
}
[data-theme="light"] .rs-live-root .topbar-premium-viewers svg {
  color: var(--rs-info);
  opacity: 0.6;
}
[data-theme="light"] .rs-live-root .topbar-premium-formula-selector {
  background: var(--rs-surface-2);
}
[data-theme="light"] .rs-live-root .topbar-premium-formula-btn {
  color: var(--rs-text-2);
}
[data-theme="light"] .rs-live-root .topbar-premium-formula-btn:hover {
  color: var(--rs-text-0);
  background: var(--rs-surface-2);
}

/* ---------- COMPACT LEADERBOARD (RaceLive sidebar) ---------- */
[data-theme="light"] .rs-live-root .compact-leaderboard-premium,
[data-theme="light"] .rs-live-root .clb-list,
[data-theme="light"] .rs-live-root .clb-header {
  background: var(--rs-surface-solid-0) !important;
  color: var(--rs-text-0);
  border-color: var(--rs-border-0);
}
[data-theme="light"] .rs-live-root .clb-title,
[data-theme="light"] .rs-live-root .clb-count {
  color: var(--rs-text-0);
}
[data-theme="light"] .rs-live-root .clb-driver {
  background: var(--rs-surface-solid-1);
  border-color: var(--rs-border-1);
  color: var(--rs-text-0);
}
[data-theme="light"] .rs-live-root .clb-tag,
[data-theme="light"] .rs-live-root .clb-team,
[data-theme="light"] .rs-live-root .clb-lap-num,
[data-theme="light"] .rs-live-root .clb-lap-total,
[data-theme="light"] .rs-live-root .clb-laps,
[data-theme="light"] .rs-live-root .clb-gap {
  color: var(--rs-text-1);
}
[data-theme="light"] .rs-live-root .clb-empty {
  color: var(--rs-text-2);
}

/* ---------- LEADERBOARD PREMIUM (LBP) ---------- */
[data-theme="light"] .rs-live-root [class^="lbp-"],
[data-theme="light"] .rs-live-root [class*=" lbp-"] {
  color: var(--rs-text-0);
}
[data-theme="light"] .rs-live-root .lbp-driver-name {
  color: var(--rs-text-0);
}
[data-theme="light"] .rs-live-root .lbp-driver-tag {
  color: var(--rs-text-2);
}
[data-theme="light"] .rs-live-root .lbp-no-penalty {
  color: var(--rs-text-3);
}

/* ---------- PILOT PREMIUM CARDS (PilotLive) ---------- */
[data-theme="light"] .rs-live-root .pilot-premium-card,
[data-theme="light"] .rs-live-root .pilot-premium-chart-card,
[data-theme="light"] .rs-live-root .pilot-premium-telemetry-card,
[data-theme="light"] .rs-live-root .pilot-premium-chart-container {
  background: var(--rs-surface-solid-0) !important;
  border: 1px solid var(--rs-border-0) !important;
  color: var(--rs-text-0);
  box-shadow: var(--rs-shadow-sm);
}
[data-theme="light"] .rs-live-root .pilot-premium-card-header {
  background: var(--rs-surface-solid-1) !important;
  color: var(--rs-text-0);
  border-bottom: 1px solid var(--rs-border-0);
}
[data-theme="light"] .rs-live-root .pilot-premium-chart-legend {
  color: var(--rs-text-1);
}
[data-theme="light"] .rs-live-root .pilot-premium-chart-legend-item {
  color: var(--rs-text-1);
}
[data-theme="light"] .rs-live-root .pilot-premium-gauge-label {
  color: var(--rs-text-2);
}

/* ---------- TOOL PREMIUM (pannelli action) ---------- */
[data-theme="light"] .rs-live-root .tool-premium-card {
  background: var(--rs-surface-solid-0) !important;
  border-color: var(--rs-border-0) !important;
  color: var(--rs-text-0);
  box-shadow: var(--rs-shadow-sm);
}
[data-theme="light"] .rs-live-root .tool-premium-title {
  color: var(--rs-text-0);
}
[data-theme="light"] .rs-live-root .tool-premium-subtitle {
  color: var(--rs-text-2);
}
[data-theme="light"] .rs-live-root .tool-premium-header {
  border-bottom: 1px solid var(--rs-border-1);
}
[data-theme="light"] .rs-live-root .tool-premium-action-btn {
  background: var(--rs-surface-solid-1);
  border: 1px solid var(--rs-border-0);
  color: var(--rs-text-0);
}
[data-theme="light"] .rs-live-root .tool-premium-action-btn:hover {
  background: var(--rs-surface-solid-2);
}

/* ---------- RACE CONTROL / RACE FLAG ---------- */
[data-theme="light"] .rs-live-root .race-control-premium-section {
  background: var(--rs-surface-solid-0);
  border: 1px solid var(--rs-border-0);
}
[data-theme="light"] .rs-live-root .race-control-section-badge {
  color: var(--rs-text-1);
}
[data-theme="light"] .rs-live-root .race-flag-premium-label {
  color: var(--rs-text-0);
}

/* ---------- PENALTY BUTTONS ---------- */
[data-theme="light"] .rs-live-root .penalty-btn-premium {
  background: var(--rs-surface-solid-1);
  border: 1px solid var(--rs-border-0);
  color: var(--rs-text-0);
}
[data-theme="light"] .rs-live-root .penalty-btn-premium-value {
  color: var(--rs-text-0);
}

/* ---------- CONFIRM DIALOG BUTTONS ---------- */
[data-theme="light"] .rs-live-root .btn-cancel-premium {
  background: var(--rs-surface-solid-1);
  border: 1px solid var(--rs-border-0);
  color: var(--rs-text-0);
}

/* ---------- COMPACT WIDGETS GENERICI (.card, .badge, ecc.) ---------- */
[data-theme="light"] .rs-live-root .card,
[data-theme="light"] .rs-live-root .card-header {
  background: var(--rs-surface-solid-0);
  border-color: var(--rs-border-0);
  color: var(--rs-text-0);
}

/* ---------- INPUTS generici dentro la live ---------- */
[data-theme="light"] .rs-live-root input,
[data-theme="light"] .rs-live-root select,
[data-theme="light"] .rs-live-root textarea {
  background: var(--rs-surface-solid-1);
  border: 1px solid var(--rs-border-0);
  color: var(--rs-text-0);
}

/* ---------- HELPTIP popup ---------- */
[data-theme="light"] .rs-live-root .helptip-popup {
  background: var(--rs-surface-solid-0);
  color: var(--rs-text-0);
  border: 1px solid var(--rs-border-0);
  box-shadow: var(--rs-shadow-md);
}
[data-theme="light"] .rs-live-root .helptip-popup-text {
  color: var(--rs-text-1);
}

/* ---------- BODY / ROOT background in light mode ---------- */
html[data-theme="light"],
html[data-theme="light"] body,
html[data-theme="light"] #root,
html[data-theme="light"] .App {
  background: var(--rs-bg-0) !important;
  color: var(--rs-text-0);
}

/* ---------- CATCH-ALL light overrides per tutti i contenitori live ---------- */
/* Forza superfici chiare e testo scuro su qualunque pannello non coperto sopra. */
[data-theme="light"] .rs-live-root .main,
[data-theme="light"] .rs-live-root .rs-live-grid,
[data-theme="light"] .rs-live-root .rs-live-full-width-section,
[data-theme="light"] .rs-live-root .map-container,
[data-theme="light"] .rs-live-root .leaderboard-premium-card,
[data-theme="light"] .rs-live-root .leaderboard-premium-header,
[data-theme="light"] .rs-live-root .leaderboard-premium-body,
[data-theme="light"] .rs-live-root .leaderboard-premium-title-section,
[data-theme="light"] .rs-live-root .leaderboard-premium-table,
[data-theme="light"] .rs-live-root .leaderboard-premium-row,
[data-theme="light"] .rs-live-root .leaderboard-premium-cell,
[data-theme="light"] .rs-live-root .leaderboard-premium-header-row,
[data-theme="light"] .rs-live-root .leaderboard-premium-subtitle,
[data-theme="light"] .rs-live-root [class^="leaderboard-premium-"],
[data-theme="light"] .rs-live-root [class*=" leaderboard-premium-"],
[data-theme="light"] .rs-live-root [class^="lb-premium-"],
[data-theme="light"] .rs-live-root [class*=" lb-premium-"],
[data-theme="light"] .rs-live-root [class^="detail-"],
[data-theme="light"] .rs-live-root [class*=" detail-"],
[data-theme="light"] .rs-live-root [class^="race-control-"],
[data-theme="light"] .rs-live-root [class*=" race-control-"],
[data-theme="light"] .rs-live-root [class^="pilot-premium-"],
[data-theme="light"] .rs-live-root [class*=" pilot-premium-"],
[data-theme="light"] .rs-live-root [class^="tool-premium-"],
[data-theme="light"] .rs-live-root [class*=" tool-premium-"] {
  background-color: transparent;
  color: var(--rs-text-0);
  border-color: var(--rs-border-0);
}

/* Le "card" vere e proprie (contenitori con sfondo) ottengono una superficie solida chiara */
[data-theme="light"] .rs-live-root .leaderboard-premium-card,
[data-theme="light"] .rs-live-root .leaderboard-premium-header,
[data-theme="light"] .rs-live-root .leaderboard-premium-body,
[data-theme="light"] .rs-live-root .rs-live-full-width-section > *,
[data-theme="light"] .rs-live-root .map-container {
  background: var(--rs-surface-solid-0) !important;
  border: 1px solid var(--rs-border-0);
  box-shadow: var(--rs-shadow-sm);
}

/* Righe tabella leaderboard dettagliata */
[data-theme="light"] .rs-live-root .leaderboard-premium-row,
[data-theme="light"] .rs-live-root .leaderboard-premium-header-row {
  background: var(--rs-surface-solid-1) !important;
  border-bottom: 1px solid var(--rs-border-1);
}
[data-theme="light"] .rs-live-root .leaderboard-premium-row:hover {
  background: var(--rs-surface-solid-2) !important;
}

/* Tutti i testi bianchi hardcoded tornano scuri dentro le card light.
   Le pagine allenamento (live e replay) usano solo i token del tema e qui
   ne perderebbero i colori: sono escluse con :where(), che non cambia la
   specificità della regola per le altre pagine. */
[data-theme="light"] .rs-live-root:where(:not(.tl-root, .td-root)) h1,
[data-theme="light"] .rs-live-root:where(:not(.tl-root, .td-root)) h2,
[data-theme="light"] .rs-live-root:where(:not(.tl-root, .td-root)) h3,
[data-theme="light"] .rs-live-root:where(:not(.tl-root, .td-root)) h4,
[data-theme="light"] .rs-live-root:where(:not(.tl-root, .td-root)) h5,
[data-theme="light"] .rs-live-root:where(:not(.tl-root, .td-root)) h6,
[data-theme="light"] .rs-live-root:where(:not(.tl-root, .td-root)) p,
[data-theme="light"] .rs-live-root:where(:not(.tl-root, .td-root)) span,
[data-theme="light"] .rs-live-root:where(:not(.tl-root, .td-root)) div,
[data-theme="light"] .rs-live-root:where(:not(.tl-root, .td-root)) td,
[data-theme="light"] .rs-live-root:where(:not(.tl-root, .td-root)) th,
[data-theme="light"] .rs-live-root:where(:not(.tl-root, .td-root)) label {
  color: inherit;
}

/* Contenuti "content" dei pannelli PilotLive (tempi giri, penalità, grafici) */
[data-theme="light"] .rs-live-root .pilot-premium-laps-content,
[data-theme="light"] .rs-live-root .pilot-premium-laps-list,
[data-theme="light"] .rs-live-root .pilot-premium-laps-header,
[data-theme="light"] .rs-live-root .pilot-premium-penalties-content,
[data-theme="light"] .rs-live-root .pilot-premium-penalties-list,
[data-theme="light"] .rs-live-root .pilot-premium-penalties-clean,
[data-theme="light"] .rs-live-root .pilot-premium-laps-empty,
[data-theme="light"] .rs-live-root .pilot-premium-chart-container,
[data-theme="light"] .rs-live-root .pilot-premium-telemetry-content,
[data-theme="light"] .rs-live-root .pilot-premium-chart-card,
[data-theme="light"] .rs-live-root .pilot-premium-laps-card,
[data-theme="light"] .rs-live-root .pilot-premium-penalties-card,
[data-theme="light"] .rs-live-root .pilot-premium-telemetry-card {
  background: var(--rs-surface-solid-0) !important;
  color: var(--rs-text-0) !important;
  border-color: var(--rs-border-0);
}
[data-theme="light"] .rs-live-root .pilot-premium-lap-row,
[data-theme="light"] .rs-live-root .pilot-premium-penalty-item {
  background: var(--rs-surface-solid-1) !important;
  color: var(--rs-text-0) !important;
  border-color: var(--rs-border-1) !important;
}
[data-theme="light"] .rs-live-root .pilot-premium-lap-row:hover {
  background: var(--rs-surface-solid-2) !important;
}
[data-theme="light"] .rs-live-root .pilot-premium-lap-num,
[data-theme="light"] .rs-live-root .pilot-premium-lap-time,
[data-theme="light"] .rs-live-root .pilot-premium-lap-sector,
[data-theme="light"] .rs-live-root .pilot-premium-lap-delta,
[data-theme="light"] .rs-live-root .pilot-premium-laps-col-compare,
[data-theme="light"] .rs-live-root .pilot-premium-laps-col-num,
[data-theme="light"] .rs-live-root .pilot-premium-laps-col-time,
[data-theme="light"] .rs-live-root .pilot-premium-laps-col-sector,
[data-theme="light"] .rs-live-root .pilot-premium-laps-col-delta,
[data-theme="light"] .rs-live-root .pilot-premium-penalty-type,
[data-theme="light"] .rs-live-root .pilot-premium-penalty-timestamp,
[data-theme="light"] .rs-live-root .pilot-premium-penalty-reason,
[data-theme="light"] .rs-live-root .pilot-premium-penalty-reason-label,
[data-theme="light"] .rs-live-root .pilot-premium-penalty-reason-text {
  color: var(--rs-text-1) !important;
}

/* Race flags (VERDE/GIALLA/ROSSA/SCACCHI) in direzione gara */
[data-theme="light"] .rs-live-root .race-flag-premium {
  background: var(--rs-surface-solid-1) !important;
  border: 1px solid var(--rs-border-0) !important;
  color: var(--rs-text-0) !important;
  box-shadow: var(--rs-shadow-sm);
}
[data-theme="light"] .rs-live-root .race-flag-premium .race-flag-premium-label {
  color: var(--rs-text-0) !important;
}
[data-theme="light"] .rs-live-root .race-flag-premium:hover {
  background: var(--rs-surface-solid-2) !important;
}
[data-theme="light"] .rs-live-root .race-flag-premium.active {
  border-color: var(--rs-accent) !important;
  box-shadow: 0 0 0 2px rgba(91, 122, 0, 0.25), var(--rs-shadow-md);
}

/* OBS OVERLAY opzioni checkbox */
[data-theme="light"] .rs-live-root .obs-premium-option,
[data-theme="light"] .rs-live-root .obs-premium-option * {
  color: var(--rs-text-0) !important;
}
[data-theme="light"] .rs-live-root .obs-premium-option {
  background: var(--rs-surface-solid-1) !important;
  border: 1px solid var(--rs-border-0) !important;
}
[data-theme="light"] .rs-live-root .obs-premium-option:hover {
  background: var(--rs-surface-solid-2) !important;
}
[data-theme="light"] .rs-live-root .obs-premium-option span {
  color: var(--rs-text-2) !important;
}
[data-theme="light"] .rs-live-root .obs-premium-option strong {
  color: var(--rs-text-0) !important;
}

/* EXPORT XML elementi lista */
[data-theme="light"] .rs-live-root .export-premium-item,
[data-theme="light"] .rs-live-root .export-premium-item * {
  color: var(--rs-text-0) !important;
}
[data-theme="light"] .rs-live-root .export-premium-item {
  background: var(--rs-surface-solid-1) !important;
  border: 1px solid var(--rs-border-0) !important;
}
[data-theme="light"] .rs-live-root .export-premium-item:hover {
  background: var(--rs-surface-solid-2) !important;
}
[data-theme="light"] .rs-live-root .export-premium-item span {
  color: var(--rs-text-2) !important;
}

/* Help text sotto i box tool */
[data-theme="light"] .rs-live-root .tool-premium-help {
  color: var(--rs-text-2) !important;
}

/* ---------- Bottone SEGUI pilota (PilotLive) in light mode ---------- */
[data-theme="light"] .rs-live-root .pilot-follow-btn {
  background: var(--rs-surface-solid-1) !important;
  border: 1px solid var(--rs-border-0) !important;
  color: var(--rs-text-1) !important;
  box-shadow: var(--rs-shadow-sm);
}
[data-theme="light"] .rs-live-root .pilot-follow-btn:hover {
  background: var(--rs-surface-solid-2) !important;
  color: var(--rs-text-0) !important;
}
[data-theme="light"] .rs-live-root .pilot-follow-btn--active {
  background: var(--rs-accent) !important;
  border-color: var(--rs-accent) !important;
  color: #ffffff !important;
}

/* ---------- DIALOG CONFERMA PENALITÀ in light mode ---------- */
[data-theme="light"] .rs-live-root .penalty-confirm-premium-dialog {
  background: var(--rs-surface-solid-0) !important;
  border: 1px solid var(--rs-border-0) !important;
  box-shadow: var(--rs-shadow-lg) !important;
  color: var(--rs-text-0);
}
[data-theme="light"] .rs-live-root .penalty-confirm-premium-dialog * {
  color: var(--rs-text-0);
}
[data-theme="light"] .rs-live-root .penalty-confirm-premium-header {
  border-bottom: 1px solid var(--rs-border-1);
}
[data-theme="light"] .rs-live-root .penalty-confirm-premium-title {
  color: var(--rs-text-0) !important;
}
[data-theme="light"] .rs-live-root .penalty-confirm-premium-text {
  color: var(--rs-text-1) !important;
}
[data-theme="light"] .rs-live-root .penalty-confirm-premium-text strong {
  color: var(--rs-warning) !important;
}
[data-theme="light"] .rs-live-root .penalty-confirm-premium-reason {
  background: var(--rs-surface-solid-1) !important;
  border: 1px solid var(--rs-border-1) !important;
  color: var(--rs-text-1) !important;
}
[data-theme="light"] .rs-live-root .penalty-confirm-premium-warning {
  color: var(--rs-text-2) !important;
}

/* ---------- TOPBAR GLOBALE (App.js header) in light mode ---------- */
[data-theme="light"] .topbar {
  background: linear-gradient(to bottom, #ffffff, #f3f5f8) !important;
  border-bottom: 1px solid var(--rs-border-0);
  box-shadow: 0 1px 0 rgba(15, 23, 42, 0.04);
}
[data-theme="light"] .topbar,
[data-theme="light"] .topbar * {
  color: var(--rs-text-0);
}
[data-theme="light"] .topbar .brand-badge {
  background: var(--rs-accent);
  color: #ffffff;
}
[data-theme="light"] .topbar .status-box {
  background: var(--rs-surface-solid-1);
  border: 1px solid var(--rs-border-0);
  color: var(--rs-text-1);
  box-shadow: var(--rs-shadow-sm);
}
[data-theme="light"] .topbar .status-box .dot {
  box-shadow: 0 0 8px rgba(15, 23, 42, 0.15);
}

/* ---------- DEVICE STATUS BAR (batteria/4G/sat) ---------- */
.pilot-device-bar {
  color: rgba(255, 255, 255, 0.72);
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  width: 100%;
  align-content: start;
}

.pilot-device-metric,
.pilot-device-summary {
  min-width: 0;
  border-radius: 12px;
  background:
    linear-gradient(180deg, color-mix(in srgb, var(--metric-color, #8b8f98) 13%, transparent), rgba(255, 255, 255, 0.025)),
    rgba(255, 255, 255, 0.035);
  border: 1px solid color-mix(in srgb, var(--metric-color, #8b8f98) 24%, rgba(255, 255, 255, 0.08));
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.05);
}

.pilot-device-metric {
  padding: 12px;
}

.pilot-device-metric--wide {
  min-height: 102px;
}

.pilot-device-metric-head {
  display: flex;
  align-items: center;
  gap: 11px;
  min-width: 0;
  color: var(--metric-color, currentColor);
}

.pilot-device-metric-head svg {
  flex: 0 0 auto;
  filter: drop-shadow(0 0 8px color-mix(in srgb, var(--metric-color, #fff) 35%, transparent));
}

.pilot-device-metric-head div {
  min-width: 0;
  display: grid;
  gap: 2px;
}

.pilot-device-metric-head span {
  color: var(--rs-text-2);
  font-size: 0.68rem;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  white-space: nowrap;
}

.pilot-device-metric-head strong {
  color: var(--metric-color, var(--rs-text-0));
  font-size: 1.2rem;
  line-height: 1;
  font-weight: 950;
  font-variant-numeric: tabular-nums;
  letter-spacing: 0;
  white-space: nowrap;
}

.pilot-device-fill {
  height: 7px;
  margin-top: 13px;
  overflow: hidden;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.10);
}

.pilot-device-fill-inner {
  height: 100%;
  min-width: 3px;
  border-radius: inherit;
  background: var(--metric-color, currentColor);
  box-shadow: 0 0 14px color-mix(in srgb, var(--metric-color, #fff) 50%, transparent);
}

.pilot-device-metric small {
  display: block;
  margin-top: 8px;
  color: var(--rs-text-2);
  font-size: 0.72rem;
  font-weight: 800;
}

.pilot-device-summary {
  grid-column: 1 / -1;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  color: var(--rs-text-1);
}

.pilot-device-summary svg {
  flex: 0 0 auto;
  color: var(--rs-accent);
  opacity: 0.95;
}

.pilot-device-summary span {
  color: var(--rs-text-1);
  font-size: 0.86rem;
  font-weight: 850;
  white-space: nowrap;
}

.pilot-device-summary strong {
  color: var(--rs-text-0);
  font-size: 1rem;
  font-variant-numeric: tabular-nums;
}

.pilot-device-summary em {
  min-width: 0;
  margin-left: auto;
  color: var(--rs-text-2);
  font-size: 0.76rem;
  font-style: normal;
  font-weight: 750;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

[data-theme="light"] .rs-live-root .pilot-device-bar {
  color: var(--rs-text-1);
}

[data-theme="light"] .rs-live-root .pilot-device-metric,
[data-theme="light"] .rs-live-root .pilot-device-summary {
  background:
    linear-gradient(180deg, color-mix(in srgb, var(--metric-color, #64748b) 10%, transparent), rgba(255, 255, 255, 0.72)),
    var(--rs-surface-solid-1);
  border-color: color-mix(in srgb, var(--metric-color, #64748b) 24%, var(--rs-border-0));
}

@media (max-width: 720px) {
  .pilot-device-bar {
    grid-template-columns: 1fr;
  }

  .pilot-device-summary {
    grid-column: auto;
    align-items: flex-start;
    flex-direction: column;
  }

  .pilot-device-summary em {
    margin-left: 0;
    white-space: normal;
  }
}

.rs-device-status {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  min-width: 0;
}

.rs-device-primary,
.rs-device-secondary {
  min-width: 0;
  border: 1px solid color-mix(in srgb, var(--metric-color, #8b8f98) 28%, rgba(255, 255, 255, 0.08));
  background:
    linear-gradient(180deg, color-mix(in srgb, var(--metric-color, #8b8f98) 12%, transparent), rgba(255, 255, 255, 0.026)),
    rgba(255, 255, 255, 0.035);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.05);
}

.rs-device-primary {
  padding: 11px 12px;
  border-radius: 12px;
}

.rs-device-primary-main {
  display: grid;
  grid-template-columns: 30px minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
  color: var(--metric-color, currentColor);
}

.rs-device-primary-main svg,
.rs-device-secondary svg {
  color: var(--metric-color, currentColor);
  filter: drop-shadow(0 0 8px color-mix(in srgb, var(--metric-color, #fff) 35%, transparent));
}

.rs-device-primary-text {
  display: grid;
  min-width: 0;
  gap: 2px;
}

.rs-device-primary-text span,
.rs-device-secondary span {
  color: var(--rs-text-2);
  font-size: 0.68rem;
  font-weight: 900;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  white-space: nowrap;
}

.rs-device-primary-text small {
  color: var(--rs-text-1);
  font-size: 0.78rem;
  font-weight: 800;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rs-device-primary-main > strong {
  color: var(--metric-color, var(--rs-text-0));
  font-size: 1.42rem;
  line-height: 1;
  font-weight: 950;
  font-variant-numeric: tabular-nums;
  letter-spacing: 0;
  white-space: nowrap;
}

.rs-device-bar-fill {
  height: 7px;
  margin-top: 10px;
  overflow: hidden;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.10);
}

.rs-device-bar-fill-inner {
  height: 100%;
  min-width: 3px;
  border-radius: inherit;
  background: var(--metric-color, currentColor);
  box-shadow: 0 0 14px color-mix(in srgb, var(--metric-color, #fff) 50%, transparent);
}

.rs-device-secondary-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}

.rs-device-secondary {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px;
  border-radius: 12px;
}

.rs-device-secondary div {
  min-width: 0;
  display: grid;
  gap: 2px;
}

.rs-device-secondary strong {
  color: var(--rs-text-0);
  font-size: 0.95rem;
  line-height: 1;
  font-weight: 900;
  font-variant-numeric: tabular-nums;
  letter-spacing: 0;
  white-space: nowrap;
}

.rs-device-footnote {
  min-height: 34px;
  display: flex;
  align-items: center;
  padding: 0 12px;
  border-radius: 10px;
  color: var(--rs-text-2);
  background: rgba(255, 255, 255, 0.025);
  border: 1px solid rgba(255, 255, 255, 0.055);
  font-size: 0.78rem;
  font-weight: 800;
}

[data-theme="light"] .rs-live-root .rs-device-primary,
[data-theme="light"] .rs-live-root .rs-device-secondary {
  background:
    linear-gradient(180deg, color-mix(in srgb, var(--metric-color, #64748b) 9%, transparent), rgba(255, 255, 255, 0.72)),
    var(--rs-surface-solid-1);
  border-color: color-mix(in srgb, var(--metric-color, #64748b) 24%, var(--rs-border-0));
}

[data-theme="light"] .rs-live-root .rs-device-footnote {
  background: var(--rs-surface-solid-1);
  border-color: var(--rs-border-0);
}

@media (max-width: 980px) {
  .rs-device-secondary-grid {
    grid-template-columns: 1fr;
  }

  .rs-device-secondary {
    min-height: 48px;
  }
}

/* ---------- PILOT LIVE: header (topbar) in light mode ---------- */
[data-theme="light"] .rs-live-root .pilot-premium-header {
  background: linear-gradient(180deg, #ffffff 0%, #f3f5f8 100%) !important;
  border-bottom: 1px solid var(--rs-border-0);
  box-shadow: var(--rs-shadow-sm);
}
[data-theme="light"] .rs-live-root .pilot-premium-header-bg {
  background: linear-gradient(90deg,
    rgba(91, 122, 0, 0.06) 0%,
    transparent 40%,
    transparent 60%,
    var(--driver-color, rgba(91, 122, 0, 0.08)) 100%) !important;
  opacity: 0.35 !important;
  filter: saturate(0.8);
}
[data-theme="light"] .rs-live-root .pilot-premium-header-content,
[data-theme="light"] .rs-live-root .pilot-premium-header-left,
[data-theme="light"] .rs-live-root .pilot-premium-header-right,
[data-theme="light"] .rs-live-root .pilot-premium-driver-info {
  color: var(--rs-text-0);
}
[data-theme="light"] .rs-live-root .pilot-premium-back-btn {
  background: var(--rs-surface-solid-1) !important;
  border: 1px solid var(--rs-border-0) !important;
  color: var(--rs-text-0) !important;
  box-shadow: var(--rs-shadow-sm);
}
[data-theme="light"] .rs-live-root .pilot-premium-back-btn:hover {
  background: var(--rs-surface-solid-2) !important;
}
[data-theme="light"] .rs-live-root .pilot-premium-status {
  background: var(--rs-surface-solid-1) !important;
  border: 1px solid var(--rs-border-0) !important;
  color: var(--rs-text-0) !important;
}
[data-theme="light"] .rs-live-root .pilot-premium-status--green {
  background: rgba(4, 120, 87, 0.10) !important;
  border-color: rgba(4, 120, 87, 0.35) !important;
  color: var(--rs-success) !important;
}
[data-theme="light"] .rs-live-root .pilot-premium-status--yellow {
  background: rgba(180, 83, 9, 0.10) !important;
  border-color: rgba(180, 83, 9, 0.40) !important;
  color: var(--rs-warning) !important;
}
[data-theme="light"] .rs-live-root .pilot-premium-status--red {
  background: rgba(185, 28, 28, 0.10) !important;
  border-color: rgba(185, 28, 28, 0.40) !important;
  color: var(--rs-danger) !important;
}
[data-theme="light"] .rs-live-root .pilot-premium-driver-tag {
  color: var(--rs-text-0) !important;
}
[data-theme="light"] .rs-live-root .pilot-premium-driver-name {
  color: var(--rs-text-2) !important;
}
[data-theme="light"] .rs-live-root .pilot-premium-position {
  background: var(--rs-surface-solid-1) !important;
  border: 1px solid var(--rs-border-0) !important;
  color: var(--rs-text-0) !important;
}
[data-theme="light"] .rs-live-root .pilot-premium-position-label,
[data-theme="light"] .rs-live-root .pilot-premium-position-value {
  color: var(--rs-text-0) !important;
}
[data-theme="light"] .rs-live-root .pilot-premium-lap-counter {
  background: var(--rs-surface-solid-1) !important;
  border: 1px solid var(--rs-border-0) !important;
  color: var(--rs-text-0) !important;
  box-shadow: var(--rs-shadow-sm);
}
[data-theme="light"] .rs-live-root .pilot-premium-lap-counter svg {
  color: var(--rs-accent);
}
[data-theme="light"] .rs-live-root .pilot-premium-lap-current {
  color: var(--rs-text-0) !important;
}

/* ---------- PILOT LIVE: larghezza colonne tempi giri ---------- */
.rs-live-root .pilot-premium-laps-header--extended,
.rs-live-root .pilot-premium-lap-row--extended {
  grid-template-columns: 40px 40px 1fr 82px 82px 82px 90px 48px !important;
  gap: 10px !important;
  padding: 12px 18px !important;
}
@media (max-width: 640px) {
  .rs-live-root .pilot-premium-laps-header--extended,
  .rs-live-root .pilot-premium-lap-row--extended {
    grid-template-columns: 30px 30px 1fr 62px 62px 62px 70px 38px !important;
    gap: 5px !important;
    padding: 10px 12px !important;
  }
}

/* ---------- PILOT LIVE: aumento font grafici/tempi/sezioni ---------- */
.rs-live-root .pilot-premium-lap-num,
.rs-live-root .pilot-premium-lap-time,
.rs-live-root .pilot-premium-lap-sector,
.rs-live-root .pilot-premium-lap-delta {
  font-size: 0.95rem !important;
}
.rs-live-root .pilot-premium-laps-col-compare,
.rs-live-root .pilot-premium-laps-col-num,
.rs-live-root .pilot-premium-laps-col-time,
.rs-live-root .pilot-premium-laps-col-sector,
.rs-live-root .pilot-premium-laps-col-delta {
  font-size: 0.78rem !important;
  letter-spacing: 0.5px;
}
.rs-live-root .pilot-premium-chart-legend,
.rs-live-root .pilot-premium-chart-legend-item {
  font-size: 0.85rem !important;
}
.rs-live-root .pilot-premium-gauge-label {
  font-size: 0.95rem !important;
}
.rs-live-root .pilot-premium-penalty-type,
.rs-live-root .pilot-premium-penalty-timestamp,
.rs-live-root .pilot-premium-penalty-reason {
  font-size: 0.9rem !important;
}
@media (max-width: 640px) {
  .rs-live-root .pilot-premium-lap-num,
  .rs-live-root .pilot-premium-lap-time,
  .rs-live-root .pilot-premium-lap-sector,
  .rs-live-root .pilot-premium-lap-delta {
    font-size: 0.82rem !important;
  }
  .rs-live-root .pilot-premium-laps-col-compare,
  .rs-live-root .pilot-premium-laps-col-num,
  .rs-live-root .pilot-premium-laps-col-time,
  .rs-live-root .pilot-premium-laps-col-sector,
  .rs-live-root .pilot-premium-laps-col-delta {
    font-size: 0.68rem !important;
  }
}

/* RaceLive: tabella leaderboard dettagliata (TEMPI GIRI / PENALITA direzione) */
[data-theme="light"] .rs-live-root .leaderboard-premium-row,
[data-theme="light"] .rs-live-root .leaderboard-premium-row *,
[data-theme="light"] .rs-live-root .leaderboard-premium-cell,
[data-theme="light"] .rs-live-root .leaderboard-premium-body {
  color: var(--rs-text-0) !important;
}
[data-theme="light"] .rs-live-root .leaderboard-premium-body {
  background: var(--rs-surface-solid-0) !important;
}

/* Forza testo scuro sugli elementi che avevano color:#fff inline o come default */
[data-theme="light"] .rs-live-root .leaderboard-premium-card *,
[data-theme="light"] .rs-live-root .compact-leaderboard-premium *,
[data-theme="light"] .rs-live-root .pilot-premium-card *,
[data-theme="light"] .rs-live-root .tool-premium-card *,
[data-theme="light"] .rs-live-root .topbar-premium * {
  border-color: var(--rs-border-1);
}

/* ---------- DR OVERLAYS (card warning direzione gara + overlay SEGNALE PERSO) ---------- */
/* Questi usano già le variabili --rs-dr-*, qui gestiamo solo eventuali
   contenitori che ospitano la card in direzione gara. */
.rs-live-root .rs-dr-alert-stack {
  position: fixed;
  top: 80px;
  right: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 1200;
  pointer-events: none;
  max-width: 360px;
}
.rs-live-root .rs-dr-alert {
  pointer-events: auto;
  padding: 12px 14px;
  border-radius: 12px;
  border: 1px solid;
  font-size: 0.82rem;
  font-weight: 600;
  line-height: 1.35;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: var(--rs-shadow-md);
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.rs-live-root .rs-dr-alert--warning {
  background: var(--rs-dr-warning-bg);
  border-color: var(--rs-dr-warning-bd);
  color: var(--rs-dr-warning-fg);
}
.rs-live-root .rs-dr-alert--lost {
  background: var(--rs-dr-lost-bg);
  border-color: var(--rs-dr-lost-bd);
  color: var(--rs-dr-lost-fg);
}
.rs-live-root .rs-dr-alert--gone {
  background: var(--rs-dr-gone-bg);
  border-color: var(--rs-dr-gone-bd);
  color: var(--rs-dr-gone-fg);
}
.rs-live-root .rs-dr-alert-title {
  font-size: 0.72rem;
  letter-spacing: 1px;
  text-transform: uppercase;
  opacity: 0.85;
}
.rs-live-root .rs-dr-alert-body {
  font-size: 0.88rem;
  font-weight: 700;
}
.rs-live-root .rs-dr-alert-meta {
  font-size: 0.72rem;
  opacity: 0.75;
  font-weight: 500;
}

/* Overlay "SEGNALE PERSO" a tutto schermo nel PilotLive */
.rs-live-root .rs-signal-lost-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  z-index: 20;
}
.rs-live-root .rs-signal-lost-card {
  background: var(--rs-dr-lost-bg);
  border: 1.5px solid var(--rs-dr-lost-bd);
  color: var(--rs-dr-lost-fg);
  padding: 22px 32px;
  border-radius: 16px;
  text-align: center;
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  box-shadow: var(--rs-shadow-lg);
  animation: rs-signal-pulse 1.6s ease-in-out infinite;
  pointer-events: auto;
}
.rs-live-root .rs-signal-lost-title {
  font-size: 1.2rem;
  font-weight: 900;
  letter-spacing: 3px;
  text-transform: uppercase;
  margin-bottom: 6px;
}
.rs-live-root .rs-signal-lost-sub {
  font-size: 0.85rem;
  opacity: 0.8;
  font-weight: 600;
}
@keyframes rs-signal-pulse {
  0%, 100% { transform: scale(1); opacity: 1; }
  50%      { transform: scale(1.03); opacity: 0.85; }
}

`, "",{"version":3,"sources":["webpack://./src/styles/legacy/live-shared-legacy.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;;;;;wEAKwE;AACxE;EACE,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA,2DAA2D;AAC3D;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA,wCAAwC;AACxC;EACE;;uFAEqF;EACrF,YAAY;AACd;AACA;;;EAGE,aAAa;EACb,sBAAsB;AACxB;;AAEA,yCAAyC;AACzC;EACE,gEAAgE;EAChE,2CAA2C;EAC3C,+BAA+B;AACjC;AACA;;;EAGE,uBAAuB;AACzB;AACA;;;EAGE,uBAAuB;AACzB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,wBAAwB;AAC1B;AACA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,+BAA+B;AACjC;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA,iEAAiE;AACjE;;;EAGE,gDAAgD;EAChD,uBAAuB;EACvB,gCAAgC;AAClC;AACA;;EAEE,uBAAuB;AACzB;AACA;EACE,qCAAqC;EACrC,gCAAgC;EAChC,uBAAuB;AACzB;AACA;;;;;;EAME,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;;AAEA,oDAAoD;AACpD;;EAEE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;;AAEA,0DAA0D;AAC1D;;;;EAIE,gDAAgD;EAChD,+CAA+C;EAC/C,uBAAuB;EACvB,+BAA+B;AACjC;AACA;EACE,gDAAgD;EAChD,uBAAuB;EACvB,2CAA2C;AAC7C;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;;AAEA,yDAAyD;AACzD;EACE,gDAAgD;EAChD,2CAA2C;EAC3C,uBAAuB;EACvB,+BAA+B;AACjC;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,qCAAqC;EACrC,oCAAoC;EACpC,uBAAuB;AACzB;AACA;EACE,qCAAqC;AACvC;;AAEA,mDAAmD;AACnD;EACE,qCAAqC;EACrC,oCAAoC;AACtC;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;;AAEA,0CAA0C;AAC1C;EACE,qCAAqC;EACrC,oCAAoC;EACpC,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;;AAEA,iDAAiD;AACjD;EACE,qCAAqC;EACrC,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA,yEAAyE;AACzE;;EAEE,qCAAqC;EACrC,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA,yDAAyD;AACzD;;;EAGE,qCAAqC;EACrC,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA,wCAAwC;AACxC;EACE,qCAAqC;EACrC,uBAAuB;EACvB,oCAAoC;EACpC,+BAA+B;AACjC;AACA;EACE,uBAAuB;AACzB;;AAEA,+DAA+D;AAC/D;;;;EAIE,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA,iFAAiF;AACjF,kFAAkF;AAClF;;;;;;;;;;;;;;;;;;;;;;;;;EAyBE,6BAA6B;EAC7B,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA,6FAA6F;AAC7F;;;;;EAKE,gDAAgD;EAChD,oCAAoC;EACpC,+BAA+B;AACjC;;AAEA,0CAA0C;AAC1C;;EAEE,gDAAgD;EAChD,2CAA2C;AAC7C;AACA;EACE,gDAAgD;AAClD;;AAEA;;;kDAGkD;AAClD;;;;;;;;;;;;EAYE,cAAc;AAChB;;AAEA,+EAA+E;AAC/E;;;;;;;;;;;;;EAaE,gDAAgD;EAChD,kCAAkC;EAClC,gCAAgC;AAClC;AACA;;EAEE,gDAAgD;EAChD,kCAAkC;EAClC,2CAA2C;AAC7C;AACA;EACE,gDAAgD;AAClD;AACA;;;;;;;;;;;;;;EAcE,kCAAkC;AACpC;;AAEA,8DAA8D;AAC9D;EACE,gDAAgD;EAChD,+CAA+C;EAC/C,kCAAkC;EAClC,+BAA+B;AACjC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,gDAAgD;AAClD;AACA;EACE,yCAAyC;EACzC,iEAAiE;AACnE;;AAEA,iCAAiC;AACjC;;EAEE,kCAAkC;AACpC;AACA;EACE,gDAAgD;EAChD,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;;AAEA,8BAA8B;AAC9B;;EAEE,kCAAkC;AACpC;AACA;EACE,gDAAgD;EAChD,+CAA+C;AACjD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,kCAAkC;AACpC;;AAEA,+BAA+B;AAC/B;EACE,kCAAkC;AACpC;;AAEA,yEAAyE;AACzE;EACE,gDAAgD;EAChD,+CAA+C;EAC/C,kCAAkC;EAClC,+BAA+B;AACjC;AACA;EACE,gDAAgD;EAChD,kCAAkC;AACpC;AACA;EACE,uCAAuC;EACvC,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA,iEAAiE;AACjE;EACE,gDAAgD;EAChD,+CAA+C;EAC/C,0CAA0C;EAC1C,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,gDAAgD;EAChD,+CAA+C;EAC/C,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;;AAEA,uEAAuE;AACvE;EACE,mEAAmE;EACnE,2CAA2C;EAC3C,0CAA0C;AAC5C;AACA;;EAEE,uBAAuB;AACzB;AACA;EACE,4BAA4B;EAC5B,cAAc;AAChB;AACA;EACE,qCAAqC;EACrC,oCAAoC;EACpC,uBAAuB;EACvB,+BAA+B;AACjC;AACA;EACE,0CAA0C;AAC5C;;AAEA,8DAA8D;AAC9D;EACE,gCAAgC;EAChC,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,WAAW;EACX,oBAAoB;AACtB;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;EACnB;;8BAE4B;EAC5B,iGAAiG;EACjG,mDAAmD;AACrD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,2FAA2F;AAC7F;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,4CAA4C;EAC5C,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,kCAAkC;EAClC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,6CAA6C;EAC7C,mFAAmF;AACrF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE;;6BAE2B;EAC3B,sFAAsF;AACxF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,YAAY;EACZ,iGAAiG;EACjG;;8BAE4B;EAC5B,mDAAmD;AACrD;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,SAAS;EACT,wCAAwC;AAC1C;;AAEA;;EAEE,wCAAwC;EACxC,2FAA2F;AAC7F;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,QAAQ;AACV;;AAEA;;EAEE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,4CAA4C;EAC5C,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,kCAAkC;EAClC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,6CAA6C;EAC7C,mFAAmF;AACrF;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,kCAAkC;EAClC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE;;6BAE2B;EAC3B,sFAAsF;AACxF;;AAEA;EACE,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,oEAAoE;AACpE;EACE,wEAAwE;EACxE,2CAA2C;EAC3C,+BAA+B;AACjC;AACA;EACE;;;;gEAI8D;EAC9D,wBAAwB;EACxB,qBAAqB;AACvB;AACA;;;;EAIE,uBAAuB;AACzB;AACA;EACE,gDAAgD;EAChD,+CAA+C;EAC/C,kCAAkC;EAClC,+BAA+B;AACjC;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;EAChD,+CAA+C;EAC/C,kCAAkC;AACpC;AACA;EACE,6CAA6C;EAC7C,+CAA+C;EAC/C,mCAAmC;AACrC;AACA;EACE,6CAA6C;EAC7C,+CAA+C;EAC/C,mCAAmC;AACrC;AACA;EACE,8CAA8C;EAC9C,gDAAgD;EAChD,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,gDAAgD;EAChD,+CAA+C;EAC/C,kCAAkC;AACpC;AACA;;EAEE,kCAAkC;AACpC;AACA;EACE,gDAAgD;EAChD,+CAA+C;EAC/C,kCAAkC;EAClC,+BAA+B;AACjC;AACA;EACE,uBAAuB;AACzB;AACA;EACE,kCAAkC;AACpC;;AAEA,mEAAmE;AACnE;;EAEE,wEAAwE;EACxE,oBAAoB;EACpB,6BAA6B;AAC/B;AACA;EACE;;IAEE,wEAAwE;IACxE,mBAAmB;IACnB,6BAA6B;EAC/B;AACF;;AAEA,yEAAyE;AACzE;;;;EAIE,6BAA6B;AAC/B;AACA;;;;;EAKE,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;;EAEE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;;;EAGE,4BAA4B;AAC9B;AACA;EACE;;;;IAIE,6BAA6B;EAC/B;EACA;;;;;IAKE,6BAA6B;EAC/B;AACF;;AAEA,gFAAgF;AAChF;;;;EAIE,kCAAkC;AACpC;AACA;EACE,gDAAgD;AAClD;;AAEA,kFAAkF;AAClF;;;;;EAKE,gCAAgC;AAClC;;AAEA,4FAA4F;AAC5F;wDACwD;AACxD;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;EAC3B,mCAAmC;EACnC,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,8BAA8B;AAChC;AACA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,2BAA2B;AAC7B;AACA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA,0DAA0D;AAC1D;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,WAAW;AACb;AACA;EACE,gCAAgC;EAChC,wCAAwC;EACxC,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;EAC3B,mCAAmC;EACnC,+BAA+B;EAC/B,oDAAoD;EACpD,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,WAAW,mBAAmB,EAAE,UAAU,EAAE;EAC5C,WAAW,sBAAsB,EAAE,aAAa,EAAE;AACpD","sourcesContent":["/* ---- from App.css lines 160-1223 ---- */\n/* ======================================================================\n   LIGHT THEME — override mirati per le dashboard live.\n   Tutti i selettori sono ancorati a `.rs-live-root` così il tema chiaro\n   agisce SOLO sulle pagine che lo opt-in (RaceLive, PilotLive, LivePublic)\n   e NON tocca il resto della piattaforma.\n====================================================================== */\n[data-theme=\"light\"] .rs-live-root {\n  background: var(--rs-bg-0) !important;\n  color: var(--rs-text-0);\n}\n\n/* Le dashboard live usano tutta la larghezza disponibile */\n.rs-live-root.main {\n  max-width: 1600px;\n  padding-left: 24px;\n  padding-right: 24px;\n}\n@media (min-width: 1800px) {\n  .rs-live-root.main {\n    max-width: 1760px;\n  }\n}\n@media (max-width: 768px) {\n  .rs-live-root.main {\n    padding-left: 10px;\n    padding-right: 10px;\n  }\n}\n\n/* Sfondo pagina e decorazioni globali */\n[data-theme=\"light\"] .rs-live-root .bg-grid {\n  background:\n    linear-gradient(rgba(11, 13, 18, 0.06) 1px, transparent 1px) 0 0 / 24px 24px,\n    linear-gradient(90deg, rgba(11, 13, 18, 0.06) 1px, transparent 1px) 0 0 / 24px 24px;\n  opacity: 0.5;\n}\n[data-theme=\"light\"] .rs-live-root .bg-glow,\n[data-theme=\"light\"] .rs-live-root .bg-glow-1,\n[data-theme=\"light\"] .rs-live-root .bg-glow-2 {\n  opacity: 0.35;\n  filter: saturate(0.75);\n}\n\n/* ---------- TOPBAR PREMIUM ---------- */\n[data-theme=\"light\"] .rs-live-root .topbar-premium {\n  background: linear-gradient(180deg, #ffffff, #f3f5f8) !important;\n  border-bottom: 1px solid var(--rs-border-0);\n  box-shadow: var(--rs-shadow-sm);\n}\n[data-theme=\"light\"] .rs-live-root .topbar-premium-circuit,\n[data-theme=\"light\"] .rs-live-root .topbar-premium-laps,\n[data-theme=\"light\"] .rs-live-root .topbar-premium-drivers {\n  color: var(--rs-text-1);\n}\n[data-theme=\"light\"] .rs-live-root .topbar-premium-circuit svg,\n[data-theme=\"light\"] .rs-live-root .topbar-premium-laps svg,\n[data-theme=\"light\"] .rs-live-root .topbar-premium-drivers svg {\n  color: var(--rs-text-2);\n}\n[data-theme=\"light\"] .rs-live-root .topbar-premium-separator {\n  background: var(--rs-border-0);\n}\n[data-theme=\"light\"] .rs-live-root .topbar-premium-status {\n  background: rgba(4, 120, 87, 0.12);\n  border-color: rgba(4, 120, 87, 0.35);\n  color: var(--rs-success);\n}\n[data-theme=\"light\"] .rs-live-root .topbar-premium-status--finita {\n  background: var(--rs-surface-2);\n  border-color: var(--rs-border-0);\n  color: var(--rs-text-1);\n}\n[data-theme=\"light\"] .rs-live-root .topbar-premium-viewers {\n  color: var(--rs-info);\n}\n[data-theme=\"light\"] .rs-live-root .topbar-premium-viewers svg {\n  color: var(--rs-info);\n  opacity: 0.6;\n}\n[data-theme=\"light\"] .rs-live-root .topbar-premium-formula-selector {\n  background: var(--rs-surface-2);\n}\n[data-theme=\"light\"] .rs-live-root .topbar-premium-formula-btn {\n  color: var(--rs-text-2);\n}\n[data-theme=\"light\"] .rs-live-root .topbar-premium-formula-btn:hover {\n  color: var(--rs-text-0);\n  background: var(--rs-surface-2);\n}\n\n/* ---------- COMPACT LEADERBOARD (RaceLive sidebar) ---------- */\n[data-theme=\"light\"] .rs-live-root .compact-leaderboard-premium,\n[data-theme=\"light\"] .rs-live-root .clb-list,\n[data-theme=\"light\"] .rs-live-root .clb-header {\n  background: var(--rs-surface-solid-0) !important;\n  color: var(--rs-text-0);\n  border-color: var(--rs-border-0);\n}\n[data-theme=\"light\"] .rs-live-root .clb-title,\n[data-theme=\"light\"] .rs-live-root .clb-count {\n  color: var(--rs-text-0);\n}\n[data-theme=\"light\"] .rs-live-root .clb-driver {\n  background: var(--rs-surface-solid-1);\n  border-color: var(--rs-border-1);\n  color: var(--rs-text-0);\n}\n[data-theme=\"light\"] .rs-live-root .clb-tag,\n[data-theme=\"light\"] .rs-live-root .clb-team,\n[data-theme=\"light\"] .rs-live-root .clb-lap-num,\n[data-theme=\"light\"] .rs-live-root .clb-lap-total,\n[data-theme=\"light\"] .rs-live-root .clb-laps,\n[data-theme=\"light\"] .rs-live-root .clb-gap {\n  color: var(--rs-text-1);\n}\n[data-theme=\"light\"] .rs-live-root .clb-empty {\n  color: var(--rs-text-2);\n}\n\n/* ---------- LEADERBOARD PREMIUM (LBP) ---------- */\n[data-theme=\"light\"] .rs-live-root [class^=\"lbp-\"],\n[data-theme=\"light\"] .rs-live-root [class*=\" lbp-\"] {\n  color: var(--rs-text-0);\n}\n[data-theme=\"light\"] .rs-live-root .lbp-driver-name {\n  color: var(--rs-text-0);\n}\n[data-theme=\"light\"] .rs-live-root .lbp-driver-tag {\n  color: var(--rs-text-2);\n}\n[data-theme=\"light\"] .rs-live-root .lbp-no-penalty {\n  color: var(--rs-text-3);\n}\n\n/* ---------- PILOT PREMIUM CARDS (PilotLive) ---------- */\n[data-theme=\"light\"] .rs-live-root .pilot-premium-card,\n[data-theme=\"light\"] .rs-live-root .pilot-premium-chart-card,\n[data-theme=\"light\"] .rs-live-root .pilot-premium-telemetry-card,\n[data-theme=\"light\"] .rs-live-root .pilot-premium-chart-container {\n  background: var(--rs-surface-solid-0) !important;\n  border: 1px solid var(--rs-border-0) !important;\n  color: var(--rs-text-0);\n  box-shadow: var(--rs-shadow-sm);\n}\n[data-theme=\"light\"] .rs-live-root .pilot-premium-card-header {\n  background: var(--rs-surface-solid-1) !important;\n  color: var(--rs-text-0);\n  border-bottom: 1px solid var(--rs-border-0);\n}\n[data-theme=\"light\"] .rs-live-root .pilot-premium-chart-legend {\n  color: var(--rs-text-1);\n}\n[data-theme=\"light\"] .rs-live-root .pilot-premium-chart-legend-item {\n  color: var(--rs-text-1);\n}\n[data-theme=\"light\"] .rs-live-root .pilot-premium-gauge-label {\n  color: var(--rs-text-2);\n}\n\n/* ---------- TOOL PREMIUM (pannelli action) ---------- */\n[data-theme=\"light\"] .rs-live-root .tool-premium-card {\n  background: var(--rs-surface-solid-0) !important;\n  border-color: var(--rs-border-0) !important;\n  color: var(--rs-text-0);\n  box-shadow: var(--rs-shadow-sm);\n}\n[data-theme=\"light\"] .rs-live-root .tool-premium-title {\n  color: var(--rs-text-0);\n}\n[data-theme=\"light\"] .rs-live-root .tool-premium-subtitle {\n  color: var(--rs-text-2);\n}\n[data-theme=\"light\"] .rs-live-root .tool-premium-header {\n  border-bottom: 1px solid var(--rs-border-1);\n}\n[data-theme=\"light\"] .rs-live-root .tool-premium-action-btn {\n  background: var(--rs-surface-solid-1);\n  border: 1px solid var(--rs-border-0);\n  color: var(--rs-text-0);\n}\n[data-theme=\"light\"] .rs-live-root .tool-premium-action-btn:hover {\n  background: var(--rs-surface-solid-2);\n}\n\n/* ---------- RACE CONTROL / RACE FLAG ---------- */\n[data-theme=\"light\"] .rs-live-root .race-control-premium-section {\n  background: var(--rs-surface-solid-0);\n  border: 1px solid var(--rs-border-0);\n}\n[data-theme=\"light\"] .rs-live-root .race-control-section-badge {\n  color: var(--rs-text-1);\n}\n[data-theme=\"light\"] .rs-live-root .race-flag-premium-label {\n  color: var(--rs-text-0);\n}\n\n/* ---------- PENALTY BUTTONS ---------- */\n[data-theme=\"light\"] .rs-live-root .penalty-btn-premium {\n  background: var(--rs-surface-solid-1);\n  border: 1px solid var(--rs-border-0);\n  color: var(--rs-text-0);\n}\n[data-theme=\"light\"] .rs-live-root .penalty-btn-premium-value {\n  color: var(--rs-text-0);\n}\n\n/* ---------- CONFIRM DIALOG BUTTONS ---------- */\n[data-theme=\"light\"] .rs-live-root .btn-cancel-premium {\n  background: var(--rs-surface-solid-1);\n  border: 1px solid var(--rs-border-0);\n  color: var(--rs-text-0);\n}\n\n/* ---------- COMPACT WIDGETS GENERICI (.card, .badge, ecc.) ---------- */\n[data-theme=\"light\"] .rs-live-root .card,\n[data-theme=\"light\"] .rs-live-root .card-header {\n  background: var(--rs-surface-solid-0);\n  border-color: var(--rs-border-0);\n  color: var(--rs-text-0);\n}\n\n/* ---------- INPUTS generici dentro la live ---------- */\n[data-theme=\"light\"] .rs-live-root input,\n[data-theme=\"light\"] .rs-live-root select,\n[data-theme=\"light\"] .rs-live-root textarea {\n  background: var(--rs-surface-solid-1);\n  border: 1px solid var(--rs-border-0);\n  color: var(--rs-text-0);\n}\n\n/* ---------- HELPTIP popup ---------- */\n[data-theme=\"light\"] .rs-live-root .helptip-popup {\n  background: var(--rs-surface-solid-0);\n  color: var(--rs-text-0);\n  border: 1px solid var(--rs-border-0);\n  box-shadow: var(--rs-shadow-md);\n}\n[data-theme=\"light\"] .rs-live-root .helptip-popup-text {\n  color: var(--rs-text-1);\n}\n\n/* ---------- BODY / ROOT background in light mode ---------- */\nhtml[data-theme=\"light\"],\nhtml[data-theme=\"light\"] body,\nhtml[data-theme=\"light\"] #root,\nhtml[data-theme=\"light\"] .App {\n  background: var(--rs-bg-0) !important;\n  color: var(--rs-text-0);\n}\n\n/* ---------- CATCH-ALL light overrides per tutti i contenitori live ---------- */\n/* Forza superfici chiare e testo scuro su qualunque pannello non coperto sopra. */\n[data-theme=\"light\"] .rs-live-root .main,\n[data-theme=\"light\"] .rs-live-root .rs-live-grid,\n[data-theme=\"light\"] .rs-live-root .rs-live-full-width-section,\n[data-theme=\"light\"] .rs-live-root .map-container,\n[data-theme=\"light\"] .rs-live-root .leaderboard-premium-card,\n[data-theme=\"light\"] .rs-live-root .leaderboard-premium-header,\n[data-theme=\"light\"] .rs-live-root .leaderboard-premium-body,\n[data-theme=\"light\"] .rs-live-root .leaderboard-premium-title-section,\n[data-theme=\"light\"] .rs-live-root .leaderboard-premium-table,\n[data-theme=\"light\"] .rs-live-root .leaderboard-premium-row,\n[data-theme=\"light\"] .rs-live-root .leaderboard-premium-cell,\n[data-theme=\"light\"] .rs-live-root .leaderboard-premium-header-row,\n[data-theme=\"light\"] .rs-live-root .leaderboard-premium-subtitle,\n[data-theme=\"light\"] .rs-live-root [class^=\"leaderboard-premium-\"],\n[data-theme=\"light\"] .rs-live-root [class*=\" leaderboard-premium-\"],\n[data-theme=\"light\"] .rs-live-root [class^=\"lb-premium-\"],\n[data-theme=\"light\"] .rs-live-root [class*=\" lb-premium-\"],\n[data-theme=\"light\"] .rs-live-root [class^=\"detail-\"],\n[data-theme=\"light\"] .rs-live-root [class*=\" detail-\"],\n[data-theme=\"light\"] .rs-live-root [class^=\"race-control-\"],\n[data-theme=\"light\"] .rs-live-root [class*=\" race-control-\"],\n[data-theme=\"light\"] .rs-live-root [class^=\"pilot-premium-\"],\n[data-theme=\"light\"] .rs-live-root [class*=\" pilot-premium-\"],\n[data-theme=\"light\"] .rs-live-root [class^=\"tool-premium-\"],\n[data-theme=\"light\"] .rs-live-root [class*=\" tool-premium-\"] {\n  background-color: transparent;\n  color: var(--rs-text-0);\n  border-color: var(--rs-border-0);\n}\n\n/* Le \"card\" vere e proprie (contenitori con sfondo) ottengono una superficie solida chiara */\n[data-theme=\"light\"] .rs-live-root .leaderboard-premium-card,\n[data-theme=\"light\"] .rs-live-root .leaderboard-premium-header,\n[data-theme=\"light\"] .rs-live-root .leaderboard-premium-body,\n[data-theme=\"light\"] .rs-live-root .rs-live-full-width-section > *,\n[data-theme=\"light\"] .rs-live-root .map-container {\n  background: var(--rs-surface-solid-0) !important;\n  border: 1px solid var(--rs-border-0);\n  box-shadow: var(--rs-shadow-sm);\n}\n\n/* Righe tabella leaderboard dettagliata */\n[data-theme=\"light\"] .rs-live-root .leaderboard-premium-row,\n[data-theme=\"light\"] .rs-live-root .leaderboard-premium-header-row {\n  background: var(--rs-surface-solid-1) !important;\n  border-bottom: 1px solid var(--rs-border-1);\n}\n[data-theme=\"light\"] .rs-live-root .leaderboard-premium-row:hover {\n  background: var(--rs-surface-solid-2) !important;\n}\n\n/* Tutti i testi bianchi hardcoded tornano scuri dentro le card light.\n   Le pagine allenamento (live e replay) usano solo i token del tema e qui\n   ne perderebbero i colori: sono escluse con :where(), che non cambia la\n   specificità della regola per le altre pagine. */\n[data-theme=\"light\"] .rs-live-root:where(:not(.tl-root, .td-root)) h1,\n[data-theme=\"light\"] .rs-live-root:where(:not(.tl-root, .td-root)) h2,\n[data-theme=\"light\"] .rs-live-root:where(:not(.tl-root, .td-root)) h3,\n[data-theme=\"light\"] .rs-live-root:where(:not(.tl-root, .td-root)) h4,\n[data-theme=\"light\"] .rs-live-root:where(:not(.tl-root, .td-root)) h5,\n[data-theme=\"light\"] .rs-live-root:where(:not(.tl-root, .td-root)) h6,\n[data-theme=\"light\"] .rs-live-root:where(:not(.tl-root, .td-root)) p,\n[data-theme=\"light\"] .rs-live-root:where(:not(.tl-root, .td-root)) span,\n[data-theme=\"light\"] .rs-live-root:where(:not(.tl-root, .td-root)) div,\n[data-theme=\"light\"] .rs-live-root:where(:not(.tl-root, .td-root)) td,\n[data-theme=\"light\"] .rs-live-root:where(:not(.tl-root, .td-root)) th,\n[data-theme=\"light\"] .rs-live-root:where(:not(.tl-root, .td-root)) label {\n  color: inherit;\n}\n\n/* Contenuti \"content\" dei pannelli PilotLive (tempi giri, penalità, grafici) */\n[data-theme=\"light\"] .rs-live-root .pilot-premium-laps-content,\n[data-theme=\"light\"] .rs-live-root .pilot-premium-laps-list,\n[data-theme=\"light\"] .rs-live-root .pilot-premium-laps-header,\n[data-theme=\"light\"] .rs-live-root .pilot-premium-penalties-content,\n[data-theme=\"light\"] .rs-live-root .pilot-premium-penalties-list,\n[data-theme=\"light\"] .rs-live-root .pilot-premium-penalties-clean,\n[data-theme=\"light\"] .rs-live-root .pilot-premium-laps-empty,\n[data-theme=\"light\"] .rs-live-root .pilot-premium-chart-container,\n[data-theme=\"light\"] .rs-live-root .pilot-premium-telemetry-content,\n[data-theme=\"light\"] .rs-live-root .pilot-premium-chart-card,\n[data-theme=\"light\"] .rs-live-root .pilot-premium-laps-card,\n[data-theme=\"light\"] .rs-live-root .pilot-premium-penalties-card,\n[data-theme=\"light\"] .rs-live-root .pilot-premium-telemetry-card {\n  background: var(--rs-surface-solid-0) !important;\n  color: var(--rs-text-0) !important;\n  border-color: var(--rs-border-0);\n}\n[data-theme=\"light\"] .rs-live-root .pilot-premium-lap-row,\n[data-theme=\"light\"] .rs-live-root .pilot-premium-penalty-item {\n  background: var(--rs-surface-solid-1) !important;\n  color: var(--rs-text-0) !important;\n  border-color: var(--rs-border-1) !important;\n}\n[data-theme=\"light\"] .rs-live-root .pilot-premium-lap-row:hover {\n  background: var(--rs-surface-solid-2) !important;\n}\n[data-theme=\"light\"] .rs-live-root .pilot-premium-lap-num,\n[data-theme=\"light\"] .rs-live-root .pilot-premium-lap-time,\n[data-theme=\"light\"] .rs-live-root .pilot-premium-lap-sector,\n[data-theme=\"light\"] .rs-live-root .pilot-premium-lap-delta,\n[data-theme=\"light\"] .rs-live-root .pilot-premium-laps-col-compare,\n[data-theme=\"light\"] .rs-live-root .pilot-premium-laps-col-num,\n[data-theme=\"light\"] .rs-live-root .pilot-premium-laps-col-time,\n[data-theme=\"light\"] .rs-live-root .pilot-premium-laps-col-sector,\n[data-theme=\"light\"] .rs-live-root .pilot-premium-laps-col-delta,\n[data-theme=\"light\"] .rs-live-root .pilot-premium-penalty-type,\n[data-theme=\"light\"] .rs-live-root .pilot-premium-penalty-timestamp,\n[data-theme=\"light\"] .rs-live-root .pilot-premium-penalty-reason,\n[data-theme=\"light\"] .rs-live-root .pilot-premium-penalty-reason-label,\n[data-theme=\"light\"] .rs-live-root .pilot-premium-penalty-reason-text {\n  color: var(--rs-text-1) !important;\n}\n\n/* Race flags (VERDE/GIALLA/ROSSA/SCACCHI) in direzione gara */\n[data-theme=\"light\"] .rs-live-root .race-flag-premium {\n  background: var(--rs-surface-solid-1) !important;\n  border: 1px solid var(--rs-border-0) !important;\n  color: var(--rs-text-0) !important;\n  box-shadow: var(--rs-shadow-sm);\n}\n[data-theme=\"light\"] .rs-live-root .race-flag-premium .race-flag-premium-label {\n  color: var(--rs-text-0) !important;\n}\n[data-theme=\"light\"] .rs-live-root .race-flag-premium:hover {\n  background: var(--rs-surface-solid-2) !important;\n}\n[data-theme=\"light\"] .rs-live-root .race-flag-premium.active {\n  border-color: var(--rs-accent) !important;\n  box-shadow: 0 0 0 2px rgba(91, 122, 0, 0.25), var(--rs-shadow-md);\n}\n\n/* OBS OVERLAY opzioni checkbox */\n[data-theme=\"light\"] .rs-live-root .obs-premium-option,\n[data-theme=\"light\"] .rs-live-root .obs-premium-option * {\n  color: var(--rs-text-0) !important;\n}\n[data-theme=\"light\"] .rs-live-root .obs-premium-option {\n  background: var(--rs-surface-solid-1) !important;\n  border: 1px solid var(--rs-border-0) !important;\n}\n[data-theme=\"light\"] .rs-live-root .obs-premium-option:hover {\n  background: var(--rs-surface-solid-2) !important;\n}\n[data-theme=\"light\"] .rs-live-root .obs-premium-option span {\n  color: var(--rs-text-2) !important;\n}\n[data-theme=\"light\"] .rs-live-root .obs-premium-option strong {\n  color: var(--rs-text-0) !important;\n}\n\n/* EXPORT XML elementi lista */\n[data-theme=\"light\"] .rs-live-root .export-premium-item,\n[data-theme=\"light\"] .rs-live-root .export-premium-item * {\n  color: var(--rs-text-0) !important;\n}\n[data-theme=\"light\"] .rs-live-root .export-premium-item {\n  background: var(--rs-surface-solid-1) !important;\n  border: 1px solid var(--rs-border-0) !important;\n}\n[data-theme=\"light\"] .rs-live-root .export-premium-item:hover {\n  background: var(--rs-surface-solid-2) !important;\n}\n[data-theme=\"light\"] .rs-live-root .export-premium-item span {\n  color: var(--rs-text-2) !important;\n}\n\n/* Help text sotto i box tool */\n[data-theme=\"light\"] .rs-live-root .tool-premium-help {\n  color: var(--rs-text-2) !important;\n}\n\n/* ---------- Bottone SEGUI pilota (PilotLive) in light mode ---------- */\n[data-theme=\"light\"] .rs-live-root .pilot-follow-btn {\n  background: var(--rs-surface-solid-1) !important;\n  border: 1px solid var(--rs-border-0) !important;\n  color: var(--rs-text-1) !important;\n  box-shadow: var(--rs-shadow-sm);\n}\n[data-theme=\"light\"] .rs-live-root .pilot-follow-btn:hover {\n  background: var(--rs-surface-solid-2) !important;\n  color: var(--rs-text-0) !important;\n}\n[data-theme=\"light\"] .rs-live-root .pilot-follow-btn--active {\n  background: var(--rs-accent) !important;\n  border-color: var(--rs-accent) !important;\n  color: #ffffff !important;\n}\n\n/* ---------- DIALOG CONFERMA PENALITÀ in light mode ---------- */\n[data-theme=\"light\"] .rs-live-root .penalty-confirm-premium-dialog {\n  background: var(--rs-surface-solid-0) !important;\n  border: 1px solid var(--rs-border-0) !important;\n  box-shadow: var(--rs-shadow-lg) !important;\n  color: var(--rs-text-0);\n}\n[data-theme=\"light\"] .rs-live-root .penalty-confirm-premium-dialog * {\n  color: var(--rs-text-0);\n}\n[data-theme=\"light\"] .rs-live-root .penalty-confirm-premium-header {\n  border-bottom: 1px solid var(--rs-border-1);\n}\n[data-theme=\"light\"] .rs-live-root .penalty-confirm-premium-title {\n  color: var(--rs-text-0) !important;\n}\n[data-theme=\"light\"] .rs-live-root .penalty-confirm-premium-text {\n  color: var(--rs-text-1) !important;\n}\n[data-theme=\"light\"] .rs-live-root .penalty-confirm-premium-text strong {\n  color: var(--rs-warning) !important;\n}\n[data-theme=\"light\"] .rs-live-root .penalty-confirm-premium-reason {\n  background: var(--rs-surface-solid-1) !important;\n  border: 1px solid var(--rs-border-1) !important;\n  color: var(--rs-text-1) !important;\n}\n[data-theme=\"light\"] .rs-live-root .penalty-confirm-premium-warning {\n  color: var(--rs-text-2) !important;\n}\n\n/* ---------- TOPBAR GLOBALE (App.js header) in light mode ---------- */\n[data-theme=\"light\"] .topbar {\n  background: linear-gradient(to bottom, #ffffff, #f3f5f8) !important;\n  border-bottom: 1px solid var(--rs-border-0);\n  box-shadow: 0 1px 0 rgba(15, 23, 42, 0.04);\n}\n[data-theme=\"light\"] .topbar,\n[data-theme=\"light\"] .topbar * {\n  color: var(--rs-text-0);\n}\n[data-theme=\"light\"] .topbar .brand-badge {\n  background: var(--rs-accent);\n  color: #ffffff;\n}\n[data-theme=\"light\"] .topbar .status-box {\n  background: var(--rs-surface-solid-1);\n  border: 1px solid var(--rs-border-0);\n  color: var(--rs-text-1);\n  box-shadow: var(--rs-shadow-sm);\n}\n[data-theme=\"light\"] .topbar .status-box .dot {\n  box-shadow: 0 0 8px rgba(15, 23, 42, 0.15);\n}\n\n/* ---------- DEVICE STATUS BAR (batteria/4G/sat) ---------- */\n.pilot-device-bar {\n  color: rgba(255, 255, 255, 0.72);\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n  width: 100%;\n  align-content: start;\n}\n\n.pilot-device-metric,\n.pilot-device-summary {\n  min-width: 0;\n  border-radius: 12px;\n  background:\n    linear-gradient(180deg, color-mix(in srgb, var(--metric-color, #8b8f98) 13%, transparent), rgba(255, 255, 255, 0.025)),\n    rgba(255, 255, 255, 0.035);\n  border: 1px solid color-mix(in srgb, var(--metric-color, #8b8f98) 24%, rgba(255, 255, 255, 0.08));\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.05);\n}\n\n.pilot-device-metric {\n  padding: 12px;\n}\n\n.pilot-device-metric--wide {\n  min-height: 102px;\n}\n\n.pilot-device-metric-head {\n  display: flex;\n  align-items: center;\n  gap: 11px;\n  min-width: 0;\n  color: var(--metric-color, currentColor);\n}\n\n.pilot-device-metric-head svg {\n  flex: 0 0 auto;\n  filter: drop-shadow(0 0 8px color-mix(in srgb, var(--metric-color, #fff) 35%, transparent));\n}\n\n.pilot-device-metric-head div {\n  min-width: 0;\n  display: grid;\n  gap: 2px;\n}\n\n.pilot-device-metric-head span {\n  color: var(--rs-text-2);\n  font-size: 0.68rem;\n  font-weight: 900;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  white-space: nowrap;\n}\n\n.pilot-device-metric-head strong {\n  color: var(--metric-color, var(--rs-text-0));\n  font-size: 1.2rem;\n  line-height: 1;\n  font-weight: 950;\n  font-variant-numeric: tabular-nums;\n  letter-spacing: 0;\n  white-space: nowrap;\n}\n\n.pilot-device-fill {\n  height: 7px;\n  margin-top: 13px;\n  overflow: hidden;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.10);\n}\n\n.pilot-device-fill-inner {\n  height: 100%;\n  min-width: 3px;\n  border-radius: inherit;\n  background: var(--metric-color, currentColor);\n  box-shadow: 0 0 14px color-mix(in srgb, var(--metric-color, #fff) 50%, transparent);\n}\n\n.pilot-device-metric small {\n  display: block;\n  margin-top: 8px;\n  color: var(--rs-text-2);\n  font-size: 0.72rem;\n  font-weight: 800;\n}\n\n.pilot-device-summary {\n  grid-column: 1 / -1;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  color: var(--rs-text-1);\n}\n\n.pilot-device-summary svg {\n  flex: 0 0 auto;\n  color: var(--rs-accent);\n  opacity: 0.95;\n}\n\n.pilot-device-summary span {\n  color: var(--rs-text-1);\n  font-size: 0.86rem;\n  font-weight: 850;\n  white-space: nowrap;\n}\n\n.pilot-device-summary strong {\n  color: var(--rs-text-0);\n  font-size: 1rem;\n  font-variant-numeric: tabular-nums;\n}\n\n.pilot-device-summary em {\n  min-width: 0;\n  margin-left: auto;\n  color: var(--rs-text-2);\n  font-size: 0.76rem;\n  font-style: normal;\n  font-weight: 750;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n[data-theme=\"light\"] .rs-live-root .pilot-device-bar {\n  color: var(--rs-text-1);\n}\n\n[data-theme=\"light\"] .rs-live-root .pilot-device-metric,\n[data-theme=\"light\"] .rs-live-root .pilot-device-summary {\n  background:\n    linear-gradient(180deg, color-mix(in srgb, var(--metric-color, #64748b) 10%, transparent), rgba(255, 255, 255, 0.72)),\n    var(--rs-surface-solid-1);\n  border-color: color-mix(in srgb, var(--metric-color, #64748b) 24%, var(--rs-border-0));\n}\n\n@media (max-width: 720px) {\n  .pilot-device-bar {\n    grid-template-columns: 1fr;\n  }\n\n  .pilot-device-summary {\n    grid-column: auto;\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .pilot-device-summary em {\n    margin-left: 0;\n    white-space: normal;\n  }\n}\n\n.rs-device-status {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: 100%;\n  min-width: 0;\n}\n\n.rs-device-primary,\n.rs-device-secondary {\n  min-width: 0;\n  border: 1px solid color-mix(in srgb, var(--metric-color, #8b8f98) 28%, rgba(255, 255, 255, 0.08));\n  background:\n    linear-gradient(180deg, color-mix(in srgb, var(--metric-color, #8b8f98) 12%, transparent), rgba(255, 255, 255, 0.026)),\n    rgba(255, 255, 255, 0.035);\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.05);\n}\n\n.rs-device-primary {\n  padding: 11px 12px;\n  border-radius: 12px;\n}\n\n.rs-device-primary-main {\n  display: grid;\n  grid-template-columns: 30px minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 10px;\n  color: var(--metric-color, currentColor);\n}\n\n.rs-device-primary-main svg,\n.rs-device-secondary svg {\n  color: var(--metric-color, currentColor);\n  filter: drop-shadow(0 0 8px color-mix(in srgb, var(--metric-color, #fff) 35%, transparent));\n}\n\n.rs-device-primary-text {\n  display: grid;\n  min-width: 0;\n  gap: 2px;\n}\n\n.rs-device-primary-text span,\n.rs-device-secondary span {\n  color: var(--rs-text-2);\n  font-size: 0.68rem;\n  font-weight: 900;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.rs-device-primary-text small {\n  color: var(--rs-text-1);\n  font-size: 0.78rem;\n  font-weight: 800;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.rs-device-primary-main > strong {\n  color: var(--metric-color, var(--rs-text-0));\n  font-size: 1.42rem;\n  line-height: 1;\n  font-weight: 950;\n  font-variant-numeric: tabular-nums;\n  letter-spacing: 0;\n  white-space: nowrap;\n}\n\n.rs-device-bar-fill {\n  height: 7px;\n  margin-top: 10px;\n  overflow: hidden;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.10);\n}\n\n.rs-device-bar-fill-inner {\n  height: 100%;\n  min-width: 3px;\n  border-radius: inherit;\n  background: var(--metric-color, currentColor);\n  box-shadow: 0 0 14px color-mix(in srgb, var(--metric-color, #fff) 50%, transparent);\n}\n\n.rs-device-secondary-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 8px;\n}\n\n.rs-device-secondary {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px;\n  border-radius: 12px;\n}\n\n.rs-device-secondary div {\n  min-width: 0;\n  display: grid;\n  gap: 2px;\n}\n\n.rs-device-secondary strong {\n  color: var(--rs-text-0);\n  font-size: 0.95rem;\n  line-height: 1;\n  font-weight: 900;\n  font-variant-numeric: tabular-nums;\n  letter-spacing: 0;\n  white-space: nowrap;\n}\n\n.rs-device-footnote {\n  min-height: 34px;\n  display: flex;\n  align-items: center;\n  padding: 0 12px;\n  border-radius: 10px;\n  color: var(--rs-text-2);\n  background: rgba(255, 255, 255, 0.025);\n  border: 1px solid rgba(255, 255, 255, 0.055);\n  font-size: 0.78rem;\n  font-weight: 800;\n}\n\n[data-theme=\"light\"] .rs-live-root .rs-device-primary,\n[data-theme=\"light\"] .rs-live-root .rs-device-secondary {\n  background:\n    linear-gradient(180deg, color-mix(in srgb, var(--metric-color, #64748b) 9%, transparent), rgba(255, 255, 255, 0.72)),\n    var(--rs-surface-solid-1);\n  border-color: color-mix(in srgb, var(--metric-color, #64748b) 24%, var(--rs-border-0));\n}\n\n[data-theme=\"light\"] .rs-live-root .rs-device-footnote {\n  background: var(--rs-surface-solid-1);\n  border-color: var(--rs-border-0);\n}\n\n@media (max-width: 980px) {\n  .rs-device-secondary-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .rs-device-secondary {\n    min-height: 48px;\n  }\n}\n\n/* ---------- PILOT LIVE: header (topbar) in light mode ---------- */\n[data-theme=\"light\"] .rs-live-root .pilot-premium-header {\n  background: linear-gradient(180deg, #ffffff 0%, #f3f5f8 100%) !important;\n  border-bottom: 1px solid var(--rs-border-0);\n  box-shadow: var(--rs-shadow-sm);\n}\n[data-theme=\"light\"] .rs-live-root .pilot-premium-header-bg {\n  background: linear-gradient(90deg,\n    rgba(91, 122, 0, 0.06) 0%,\n    transparent 40%,\n    transparent 60%,\n    var(--driver-color, rgba(91, 122, 0, 0.08)) 100%) !important;\n  opacity: 0.35 !important;\n  filter: saturate(0.8);\n}\n[data-theme=\"light\"] .rs-live-root .pilot-premium-header-content,\n[data-theme=\"light\"] .rs-live-root .pilot-premium-header-left,\n[data-theme=\"light\"] .rs-live-root .pilot-premium-header-right,\n[data-theme=\"light\"] .rs-live-root .pilot-premium-driver-info {\n  color: var(--rs-text-0);\n}\n[data-theme=\"light\"] .rs-live-root .pilot-premium-back-btn {\n  background: var(--rs-surface-solid-1) !important;\n  border: 1px solid var(--rs-border-0) !important;\n  color: var(--rs-text-0) !important;\n  box-shadow: var(--rs-shadow-sm);\n}\n[data-theme=\"light\"] .rs-live-root .pilot-premium-back-btn:hover {\n  background: var(--rs-surface-solid-2) !important;\n}\n[data-theme=\"light\"] .rs-live-root .pilot-premium-status {\n  background: var(--rs-surface-solid-1) !important;\n  border: 1px solid var(--rs-border-0) !important;\n  color: var(--rs-text-0) !important;\n}\n[data-theme=\"light\"] .rs-live-root .pilot-premium-status--green {\n  background: rgba(4, 120, 87, 0.10) !important;\n  border-color: rgba(4, 120, 87, 0.35) !important;\n  color: var(--rs-success) !important;\n}\n[data-theme=\"light\"] .rs-live-root .pilot-premium-status--yellow {\n  background: rgba(180, 83, 9, 0.10) !important;\n  border-color: rgba(180, 83, 9, 0.40) !important;\n  color: var(--rs-warning) !important;\n}\n[data-theme=\"light\"] .rs-live-root .pilot-premium-status--red {\n  background: rgba(185, 28, 28, 0.10) !important;\n  border-color: rgba(185, 28, 28, 0.40) !important;\n  color: var(--rs-danger) !important;\n}\n[data-theme=\"light\"] .rs-live-root .pilot-premium-driver-tag {\n  color: var(--rs-text-0) !important;\n}\n[data-theme=\"light\"] .rs-live-root .pilot-premium-driver-name {\n  color: var(--rs-text-2) !important;\n}\n[data-theme=\"light\"] .rs-live-root .pilot-premium-position {\n  background: var(--rs-surface-solid-1) !important;\n  border: 1px solid var(--rs-border-0) !important;\n  color: var(--rs-text-0) !important;\n}\n[data-theme=\"light\"] .rs-live-root .pilot-premium-position-label,\n[data-theme=\"light\"] .rs-live-root .pilot-premium-position-value {\n  color: var(--rs-text-0) !important;\n}\n[data-theme=\"light\"] .rs-live-root .pilot-premium-lap-counter {\n  background: var(--rs-surface-solid-1) !important;\n  border: 1px solid var(--rs-border-0) !important;\n  color: var(--rs-text-0) !important;\n  box-shadow: var(--rs-shadow-sm);\n}\n[data-theme=\"light\"] .rs-live-root .pilot-premium-lap-counter svg {\n  color: var(--rs-accent);\n}\n[data-theme=\"light\"] .rs-live-root .pilot-premium-lap-current {\n  color: var(--rs-text-0) !important;\n}\n\n/* ---------- PILOT LIVE: larghezza colonne tempi giri ---------- */\n.rs-live-root .pilot-premium-laps-header--extended,\n.rs-live-root .pilot-premium-lap-row--extended {\n  grid-template-columns: 40px 40px 1fr 82px 82px 82px 90px 48px !important;\n  gap: 10px !important;\n  padding: 12px 18px !important;\n}\n@media (max-width: 640px) {\n  .rs-live-root .pilot-premium-laps-header--extended,\n  .rs-live-root .pilot-premium-lap-row--extended {\n    grid-template-columns: 30px 30px 1fr 62px 62px 62px 70px 38px !important;\n    gap: 5px !important;\n    padding: 10px 12px !important;\n  }\n}\n\n/* ---------- PILOT LIVE: aumento font grafici/tempi/sezioni ---------- */\n.rs-live-root .pilot-premium-lap-num,\n.rs-live-root .pilot-premium-lap-time,\n.rs-live-root .pilot-premium-lap-sector,\n.rs-live-root .pilot-premium-lap-delta {\n  font-size: 0.95rem !important;\n}\n.rs-live-root .pilot-premium-laps-col-compare,\n.rs-live-root .pilot-premium-laps-col-num,\n.rs-live-root .pilot-premium-laps-col-time,\n.rs-live-root .pilot-premium-laps-col-sector,\n.rs-live-root .pilot-premium-laps-col-delta {\n  font-size: 0.78rem !important;\n  letter-spacing: 0.5px;\n}\n.rs-live-root .pilot-premium-chart-legend,\n.rs-live-root .pilot-premium-chart-legend-item {\n  font-size: 0.85rem !important;\n}\n.rs-live-root .pilot-premium-gauge-label {\n  font-size: 0.95rem !important;\n}\n.rs-live-root .pilot-premium-penalty-type,\n.rs-live-root .pilot-premium-penalty-timestamp,\n.rs-live-root .pilot-premium-penalty-reason {\n  font-size: 0.9rem !important;\n}\n@media (max-width: 640px) {\n  .rs-live-root .pilot-premium-lap-num,\n  .rs-live-root .pilot-premium-lap-time,\n  .rs-live-root .pilot-premium-lap-sector,\n  .rs-live-root .pilot-premium-lap-delta {\n    font-size: 0.82rem !important;\n  }\n  .rs-live-root .pilot-premium-laps-col-compare,\n  .rs-live-root .pilot-premium-laps-col-num,\n  .rs-live-root .pilot-premium-laps-col-time,\n  .rs-live-root .pilot-premium-laps-col-sector,\n  .rs-live-root .pilot-premium-laps-col-delta {\n    font-size: 0.68rem !important;\n  }\n}\n\n/* RaceLive: tabella leaderboard dettagliata (TEMPI GIRI / PENALITA direzione) */\n[data-theme=\"light\"] .rs-live-root .leaderboard-premium-row,\n[data-theme=\"light\"] .rs-live-root .leaderboard-premium-row *,\n[data-theme=\"light\"] .rs-live-root .leaderboard-premium-cell,\n[data-theme=\"light\"] .rs-live-root .leaderboard-premium-body {\n  color: var(--rs-text-0) !important;\n}\n[data-theme=\"light\"] .rs-live-root .leaderboard-premium-body {\n  background: var(--rs-surface-solid-0) !important;\n}\n\n/* Forza testo scuro sugli elementi che avevano color:#fff inline o come default */\n[data-theme=\"light\"] .rs-live-root .leaderboard-premium-card *,\n[data-theme=\"light\"] .rs-live-root .compact-leaderboard-premium *,\n[data-theme=\"light\"] .rs-live-root .pilot-premium-card *,\n[data-theme=\"light\"] .rs-live-root .tool-premium-card *,\n[data-theme=\"light\"] .rs-live-root .topbar-premium * {\n  border-color: var(--rs-border-1);\n}\n\n/* ---------- DR OVERLAYS (card warning direzione gara + overlay SEGNALE PERSO) ---------- */\n/* Questi usano già le variabili --rs-dr-*, qui gestiamo solo eventuali\n   contenitori che ospitano la card in direzione gara. */\n.rs-live-root .rs-dr-alert-stack {\n  position: fixed;\n  top: 80px;\n  right: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  z-index: 1200;\n  pointer-events: none;\n  max-width: 360px;\n}\n.rs-live-root .rs-dr-alert {\n  pointer-events: auto;\n  padding: 12px 14px;\n  border-radius: 12px;\n  border: 1px solid;\n  font-size: 0.82rem;\n  font-weight: 600;\n  line-height: 1.35;\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  box-shadow: var(--rs-shadow-md);\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.rs-live-root .rs-dr-alert--warning {\n  background: var(--rs-dr-warning-bg);\n  border-color: var(--rs-dr-warning-bd);\n  color: var(--rs-dr-warning-fg);\n}\n.rs-live-root .rs-dr-alert--lost {\n  background: var(--rs-dr-lost-bg);\n  border-color: var(--rs-dr-lost-bd);\n  color: var(--rs-dr-lost-fg);\n}\n.rs-live-root .rs-dr-alert--gone {\n  background: var(--rs-dr-gone-bg);\n  border-color: var(--rs-dr-gone-bd);\n  color: var(--rs-dr-gone-fg);\n}\n.rs-live-root .rs-dr-alert-title {\n  font-size: 0.72rem;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  opacity: 0.85;\n}\n.rs-live-root .rs-dr-alert-body {\n  font-size: 0.88rem;\n  font-weight: 700;\n}\n.rs-live-root .rs-dr-alert-meta {\n  font-size: 0.72rem;\n  opacity: 0.75;\n  font-weight: 500;\n}\n\n/* Overlay \"SEGNALE PERSO\" a tutto schermo nel PilotLive */\n.rs-live-root .rs-signal-lost-overlay {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n  z-index: 20;\n}\n.rs-live-root .rs-signal-lost-card {\n  background: var(--rs-dr-lost-bg);\n  border: 1.5px solid var(--rs-dr-lost-bd);\n  color: var(--rs-dr-lost-fg);\n  padding: 22px 32px;\n  border-radius: 16px;\n  text-align: center;\n  backdrop-filter: blur(14px);\n  -webkit-backdrop-filter: blur(14px);\n  box-shadow: var(--rs-shadow-lg);\n  animation: rs-signal-pulse 1.6s ease-in-out infinite;\n  pointer-events: auto;\n}\n.rs-live-root .rs-signal-lost-title {\n  font-size: 1.2rem;\n  font-weight: 900;\n  letter-spacing: 3px;\n  text-transform: uppercase;\n  margin-bottom: 6px;\n}\n.rs-live-root .rs-signal-lost-sub {\n  font-size: 0.85rem;\n  opacity: 0.8;\n  font-weight: 600;\n}\n@keyframes rs-signal-pulse {\n  0%, 100% { transform: scale(1); opacity: 1; }\n  50%      { transform: scale(1.03); opacity: 0.85; }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
